import { Component, ComponentInterface, Host, h, Prop } from "@stencil/core";

import { fixIEShadowDom } from "../../../../../utils/fix-ie-shadow-dom";

@Component({
    tag: "c-bubble-info",
    styleUrl: "c-bubble-info.scss",
})
export class CBubbleInfo implements ComponentInterface {
    @Prop() text: string;
    @Prop() info: string;
    // Needed for aria-describedby in feedback component
    @Prop() bubbleId: string;
    @Prop() withFeedback: boolean | undefined;

    render() {
        return (
            <Host>
                <div
                    class={
                        this.withFeedback
                            ? "bubble-container-with-feedback"
                            : ""
                    }
                >
                    <section
                        id={this.bubbleId}
                        innerHTML={this.text}
                        class={this.withFeedback ? "bubble-with-feedback" : ""}
                    >
                        <div class="info-container">
                            <i
                                id="info-icon"
                                aria-hidden="true"
                                class="info-icon"
                            ></i>
                            <span
                                id="info-text"
                                class="info-text"
                                innerHTML={fixIEShadowDom(
                                    this.info,
                                    "c-bubble-info"
                                )}
                            ></span>
                        </div>
                    </section>
                    {this.withFeedback && (
                        <c-feedback bubbleId={this.bubbleId}></c-feedback>
                    )}
                </div>
            </Host>
        );
    }
}
